<!-- this component is a shared component to let the user know that 2 fields don't match. ie: password and password confirm screen -->
<!--<field-match-component v-model="passwordsMatchVariable" :fieldvalue1="model.newPassword1" :fieldvalue2="model.newPassword2" errormessage="Password values don't match." textmatchmessage="Password matches"></field-match-component> -->
<!-- match.fields.scss will give you the background colors. That is not brought in by default since that is portal specific  -->
<template>

    <span>{{errrorToShow}}</span>

</template>

<script>

    export default {
        name: 'field-match-component',
        props: ['fieldvalue1', 'fieldvalue2', 'errormessage', 'textmatchmessage'],
        data: function () {
            return {
                showErrorMessage: false
            }
        },
        computed: {

            errrorToShow: function () {

                let valueMatches = this.fieldvalue1 == this.fieldvalue2;

                //emit this for 2 way binding
                this.$emit('input', valueMatches);

                if (valueMatches) {
                    return this.textmatchmessage;
                }

                return this.errormessage;
            }

        }
    };
</script>
